import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { postVisitorGroupBooking } from "../../../hooks/Remote/Schedule/visitor-group-booking.api";
import {
  buildTeamVisitorGroupBookingUsers,
  resolveTeamVisitorGroupLocationInventoryId
} from "../functions/team-visitor-group-booking.functions";
import { BookingStrategyContext } from "./bookingStrategies";

export const teamVisitorGroupPlaceStrategy = (ctx: BookingStrategyContext) => {
  const users = buildTeamVisitorGroupBookingUsers(
    ctx.inputs.usersBookedFor,
    ctx.sub,
    ctx.inputs,
    ctx.timezoneMobileWorking
  );

  const automatedSeating = ctx.inputs.automatedSeating;
  const automatedSeatingObjects = automatedSeating ? ctx.inputs.automatedSeatingObjects : [];

  ctx.handlePromise(
    postVisitorGroupBooking({
      users,
      bookingType: BookingType.WORKPLACE,
      locationInventoryId: resolveTeamVisitorGroupLocationInventoryId(ctx.inputs),
      automatedSeating,
      automatedSeatingObjects,
      weekdays: ctx.inputs.weekdays,
      ...ctx.standardBookingInfo,
      ...ctx.standardBookingTimes
    }),
    () => {
      ctx.onSuccess();
      ctx.conferenceBookingUsers(
        ctx.conferenceInputs,
        ctx.inputs,
        ctx.conferenceBooking,
        ctx.sub,
        ctx.timezoneMobileWorking,
        ctx.onError
      );
    },
    ctx.onError
  );
};
